module.exports = __webpack_public_path__ + "img/fhc-logo.2073708b.png";